import {useUserContext} from "@/hooks/useUserContext.ts";
import {useTenantNavigation} from "@/utils/urlUtils.ts";

export function useAuthUtils() {
  const { user } = useUserContext();
  const authUrl = import.meta.env.VITE_DEADALUS;

  const isUserInRole = (role: string): boolean => {
    return user?.roles?.some(r => r.systemName === role) ?? false;
  };

  const userHasRoles = (roles: string): boolean => {
    const roleList = roles.split(',').map(r => r.trim().toLowerCase());
    return user?.roles?.some(r => roleList.includes(r.systemName.toLowerCase())) ?? false;
  };

  const currentClientHasSubsidiary = (): boolean => {
    return user?.clientInfo?.hasSubsidiary;
  };

  const userIsClient = (): boolean => {
    return user?.userIsClient;
  };

  function authRedirect() {
    const { buildTenantPath } = useTenantNavigation();
    const redirectPath = buildTenantPath();
    window.location.href = redirectPath !== '/' ? redirectPath : authUrl;
  }

  return { isUserInRole, currentClientHasSubsidiary, userIsClient, userHasRoles, authRedirect };
}
